<template>
    <div class="equipment-list-widget">

        <div class="card">
            <h3 class="card-header d-flex justify-content-between">
                Equipment
                <div class="d-flex justify-content-between mt-2 mt-sm-0">
                    <router-link to="/equipment/list"
                                 class="link-light">
                        View All
                        <b-icon-truck/>
                    </router-link>
                    <router-link class="link-light ml-sm-4"
                                 variant="primary"
                                 :to="{name:'equipmentCreate', params: { companyId: $user.getCompanyId()}}">
                        New Equipment
                        <b-icon-plus-square/>
                    </router-link>
                </div>
            </h3>
            <div class="card-body">
                <data-table
                    ref="dataTable"
                    :show-pager="true"
                    :show-filters="false"
                    :get-items="getItems"
                    :fields="fields">
                    <template v-slot:customField="slotProps">
                        <template v-if="slotProps.row.field.key === 'actions'">
                            <div class="d-flex">
                                <b-btn size="sm"
                                       variant="secondary"
                                       @click="viewItem(slotProps.row.item)">
                                    <b-icon-eye font-scale="1"/>
                                </b-btn>
                                <b-btn size="sm"
                                       class="btn-icon ml-2"
                                       variant="secondary"
                                       :to="`/equipment/edit/${slotProps.row.item.id}`"
                                       v-if="canEdit">
                                    <b-icon-pencil/>
                                </b-btn>
                            </div>
                        </template>
                        <div v-else-if="slotProps.row.field.key === 'type'">
                            {{ getType(slotProps.row.item) }}
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'compliance_expiration'" class="text-nowrap">
                            <timestamp
                                :date-warning="true"
                                :include-year="true"
                                :includeTime="false"
                                :date="slotProps.row.item.compliance_expiration"/>
                            <calendar-add :title="calendarTitle(slotProps.row.item)"
                                          :date="calendarDate(slotProps.row.item)"
                                          :details="calendarDetails(slotProps.row.item)"/>
                        </div>
                        <template v-else>
                            {{ slotProps.row.item[slotProps.row.field.key] }}
                        </template>
                    </template>
                </data-table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import Equipment from '@/models/Equipment'

export default {
    name: 'EquipmentListWidget',
    data () {
        return {
            fields: [
                { key: 'vehicle_id', sortable: true, label: 'Vehicle ID' },
                { key: 'equipment_model', sortable: true, label: 'Model' },
                { key: 'compliance_expiration', sortable: true, label: 'Expiration', type: 'timestamp' },
                { key: 'on_road', sortable: false, label: 'On Road', type: 'boolean' },
                { key: 'type', sortable: false, label: 'Type' },
                { key: 'actions', sortable: false, label: 'Actions' },
            ],
            compliance_expiration: new Date()
        }
    },
    computed: {
        canEdit () {
            return this.$user.isSuperAdmin() || this.$user.isAdmin() ||
                this.$user.isEquipmentOwner() || this.$user.isOwnersRepresentative()
        },
    },
    methods: {
        getItems (listParams) {
            const filters = { company_id: { field: 'company_id', type: 'hidden', value: this.$user.getCompanyId() } }
            const expands = []
            return this.$api.getItems(this, 'equipment', filters, listParams, expands)
            // //  DEBUGGING TO ADD A FUTURE DATE
            // .then((items) => {
            //     let dateTest = new Date()
            //     dateTest.setDate(dateTest.getDate() + 2)
            //     return items.map((item) => {
            //         return {...item, compliance_expiration: dateTest.toISOString()}
            //     })
            // })
        },
        getType (item) {
            return Equipment.getTypeLabel(item.type)
        },
        viewItem (item) {
            this.$router.push(`/equipment/view/${item.id}`)
        },
        calendarTitle (item) {
            return 'Compliance Expiration for ' + item.vehicle_id
        },
        calendarDetails (item) {
            if (item.compliance_expiration) {
                const vehicle_id = item.vehicle_id
                const expiration = moment.utc(item.compliance_expiration).local().format('MMMM DD, YYYY')
                const link = `${location.origin}/equipment/view/${item.id}`
                return `Vehicle ${vehicle_id} compliance expiration is ${expiration}. ${link}`
            } else {
                return ''
            }
        },
        calendarDate (item) {
            return item.compliance_expiration
        }
    }
}
</script>
